import { render, staticRenderFns } from "./MatriculasCard.vue?vue&type=template&id=0f096a5e&scoped=true"
import script from "./MatriculasCard.vue?vue&type=script&lang=js"
export * from "./MatriculasCard.vue?vue&type=script&lang=js"
import style0 from "./MatriculasCard.vue?vue&type=style&index=0&id=0f096a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f096a5e",
  null
  
)

export default component.exports